import type { AxiosRequestConfig } from 'axios'

const useApiFetch = () => {
  const { $api } = useNuxtApp()

  const fetch: <T>(config: AxiosRequestConfig, returnResponse?: boolean) => Promise<T> = config => {
    const url = config.url as string

    return $api(url, {
      method: config.method as any,
      body: config.data,
      headers: {
        'Content-Type': 'application/json',
      },
      params: config.params,
      ...(config.baseURL ? { baseURL: config.baseURL } : {}),
    })
  }

  return {
    fetch,
  }
}
export default useApiFetch
